var map = {
	"./new_h_adult002.json": [
		36464,
		6464
	],
	"./new_h_default.json": [
		47663,
		7663
	],
	"./new_h_default_eur.json": [
		53536,
		3536
	],
	"./new_h_default_gbp.json": [
		21107,
		1107
	],
	"./new_h_essential.json": [
		93252,
		3252
	],
	"./new_h_habit002.json": [
		56246,
		6246
	],
	"./new_h_names002.json": [
		83548,
		3548
	],
	"./new_h_names003.json": [
		60723,
		723
	],
	"./new_h_names004.json": [
		66002,
		6002
	],
	"./new_h_read003b.json": [
		88628,
		8628
	],
	"./new_h_reading.json": [
		48329,
		8329
	],
	"./new_h_seniors_o.json": [
		77589,
		7589
	],
	"./new_h_seniors_s.json": [
		34147,
		4147
	],
	"./new_h_student.json": [
		22682,
		2682
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 91417;
module.exports = webpackAsyncContext;